import classNames from 'classnames';
import {observer} from 'mobx-react';
import React, { createRef, useEffect } from 'react';

import {Logger} from '@ok/web/modules/logger/StatLogger';
import type {BaseBannerHook} from 'OK/ads/banner/hook/BaseBannerHook';
import {BannerWithOptionsHook} from 'OK/ads/banner/hook/BannerWithOptionsHook';
import type {IBannerJson} from 'OK/ads/banner/hook/IBannerJson';
import {prepare} from 'OK/ads/banner/prepare';

import css from './AdBanner.styl';

prepare({statLogger: Logger});

export type IBaseBannerHookType = typeof BaseBannerHook<IBannerJson>;

export interface IAdBannerProps {
    /**
     * Тип хука, используемого для подключения рекламного баннера.
     */
    bannerHookType?: IBaseBannerHookType;
    bannerName: string;
    bannerParams: IBannerJson;
    className?: string;
}

export const AdBanner: React.FC<IAdBannerProps> = observer((props) => {
    const { bannerHookType, bannerName, bannerParams } = props;

    const boxRef = createRef<HTMLDivElement>();

    useEffect(() => {
        let bannerHook: BaseBannerHook<IBannerJson> | undefined;
        if (boxRef.current) {
            const HookType = bannerHookType || BannerWithOptionsHook;
            bannerHook = new HookType({
                bannerName,
                bannerParams,
                element: boxRef.current
            });
            bannerHook.activate();
        }

        return () => {
            bannerHook?.deactivate();
        };
    }, [bannerHookType, bannerName, bannerParams, boxRef]);

    return (
        <div ref={boxRef} className={classNames(css['ad-banner'], props.className)}>
        </div>
    );
});
